import { IPromise } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { IConnectionData, IInsight } from "../../models/models";
import { IBrowseInsightsActionParams, IBuildInsightContext, IUpdateInsightSelectorDataActionParams } from "./models";

export class InsightSelectorService {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  openBuildInsightModal(args: {
    insight: IInsight;
    connectionData: IConnectionData;
    canGoBack: boolean;
  }): IPromise<IUpdateInsightSelectorDataActionParams | IBrowseInsightsActionParams> {
    return this.$uibModal.open({
      templateUrl: require("./build-insight/build-insight.jade"),
      windowClass: "insight-builder-modal",
      resolve: {
        buildInsightContext: (): IBuildInsightContext => ({
          confirmedInsight: args.insight,
          connectionData: args.connectionData,
          canGoBack: args.canGoBack,
        }),
      },
      controller: "BuildInsightCtrl",
    }).result;
  }
}
